export default __webpack_public_path__ + "maps-examples-source-custom-vector-1200-08d4d0a165c7f79610253c48f4cbd3a5.png";